//import LandingProductHero from "./LandingProductHero"
import HomePageHero from "./HomePageHero"

//export default LandingProductHero
export default HomePageHero
